import React, { useEffect, useState } from 'react';
import { Card, Form, Input, Button, Switch, Space, Alert } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { getSettings, updateSettings } from '../store/slices/settingSlice';
import { useForm } from 'antd/es/form/Form';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import Can from '../permission/Can';

const Settings = () => {
    const dispatch = useDispatch()
    const [form] = useForm()
    const [loading, setLoading] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [alertType, setAlertType] = useState("success");
    const { settings } = useSelector((state) => state?.settings)
    useEffect(() => {
        dispatch(getSettings())
    }, [dispatch])
    useEffect(() => {
        if (settings?.data) {
            const initialValues = settings?.data?.reduce((acc, item) => {
                acc[`setting-${item._id}`] = item.value;
                return acc;
            }, {});
            form.setFieldsValue(initialValues)
        }
    }, [settings, form])
    const onFinish = async (values) => {
        setLoading(true);
        setAlertMessage("");
        try {
            await new Promise(resolve => setTimeout(resolve, 1000));
            const result = await dispatch(updateSettings(values))
            if (updateSettings.fulfilled.match(result)) {
                setAlertMessage(result?.payload?.message || 'Settings updated successfully!');
                setAlertType('success');
                setTimeout(() => {
                    setAlertMessage('');
                }, 4000);
            } else {
                setAlertMessage(result?.payload?.error || 'Error updating settings');
                setAlertType('error');
            }
        } catch (error) {
            setAlertMessage('Error updating settings.');
            setAlertType('error');
            console.log(error)
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <h1 style={{ marginBottom: 24 }}>Settings</h1>
            <Card title="General Settings" style={{ marginBottom: 16 }}>
            {alertMessage && (
                    <Alert
                        message={alertMessage}
                        type={alertType}
                        showIcon
                        icon={alertType === 'success' ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                        closable
                        onClose={() => setAlertMessage('')}
                        style={{
                            marginBottom: 24,
                            borderRadius: '8px',
                        }}
                    />
                )}
                <Form
                    layout="vertical"
                    onFinish={onFinish}
                    form={form}
                >
                    {settings?.data?.length > 0 ? (
                        settings?.data?.map(data => (
                            <Form.Item
                                key={data?._id}
                                label={data?.title}
                                name={`setting-${data?._id}`}
                                rules={[{ required: true, message: `Please input ${data?.title}!` }]}
                            >
                                <Input placeholder={`Enter ${data?.title}`} />
                            </Form.Item>
                        ))
                    ) : ""}
                    <Can permission="update_setting">
                        <Form.Item>
                            <Space>
                                <Button loading={loading} type="primary" htmlType="submit">
                                    Save Changes
                                </Button>
                                <Button>Cancel</Button>
                            </Space>
                        </Form.Item>
                    </Can>
                </Form>
            </Card>
        </div>
    );
};

export default Settings;

